module.exports = __webpack_public_path__ + "static/searchResultFront-9f9ff12c009a53e30157c1cd9b55006f.png";